export const locale = {
    lang: 'es',
    data: {
        GRUAS: {
            LIST: {
                TITLE: 'GRÚAS'
            }
        }
    }
};
